import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Helpers
import { formatNumber } from '../../utils/helpers';
// Components
import Currency from '../Currency';

// Styles
import styles from './Amount.styl';

const cx = classNames.bind(styles);

export default function Amount(props) {
  const { className, value, newValue, showCurrency, size, prefix, bonus, variation } = props;
  const intl = useIntl();
  const currentPrice = newValue !== undefined && newValue !== value ? newValue : value;
  const oldPrice = newValue !== undefined && newValue !== value ? value : false;
  const currency = bonus ? <FormattedMessage id="bonus" /> : <Currency />;

  if (oldPrice !== false) {
    return (
      <div
        className={cx('Amount', className, {
          [`Amount_size_${size}`]: size,
        })}
      >
        {Boolean(oldPrice) && (
          <div className={cx('Amount__oldPrice')}>
            {formatNumber(oldPrice, { digits: 2 })} {showCurrency && currency}
          </div>
        )}
        {Boolean(prefix) && <span className={cx('Amount__prefix')}>{prefix} </span>}
        <div className={cx('Amount__price')}>
          {formatNumber(currentPrice, { digits: 2 })} {showCurrency && currency}
        </div>
      </div>
    );
  }
  return (
    <div
      className={cx('Amount', 'Amount__price', className, {
        [`Amount_size_${size}`]: size,
      })}
    >
      {Boolean(prefix) && <span className={cx('Amount__prefix')}>{prefix} </span>}
      {formatNumber(currentPrice, { digits: 2 })} {showCurrency && currency}
      {variation?.deposit && (
        <div>
          {/*{variation?.ingredients?.map(item => {*/}
          {/*  return (*/}
          {/*    <div*/}
          {/*      style={{*/}
          {/*        display: 'flex',*/}
          {/*        justifyContent: 'center',*/}
          {/*        alignItems: 'center',*/}
          {/*        fontSize: '12px',*/}
          {/*      }}*/}
          {/*      key={item?.id}*/}
          {/*    >*/}
          {/*      + {item?.name} {item?.price} {currency}*/}
          {/*    </div>*/}
          {/*  );*/}
          {/*})}*/}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '12px',
            }}
          >
            + {intl.formatMessage({ id: 'productcard.deposit' })} {variation?.deposit} {currency}
          </div>
        </div>
      )}
    </div>
  );
}

Amount.defaultProps = {
  className: '',
  value: '-',
  size: 'l',
  showCurrency: true,
  prefix: '',
  bonus: false,
  newValue: undefined,
  variation: undefined,
};

Amount.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  newValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, undefined]),
  className: PropTypes.string,
  showCurrency: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 's', 'm', 'l']),
  prefix: PropTypes.any,
  bonus: PropTypes.bool,
  variation: PropTypes.object,
};
